import ApiEventHandler from './schema/ApiEventHandler';
import ApiEventRegisterArgs from './schema/ApiEventRegisterArgs';
import invokeCallback from './utils/invokeCallback';
import invokePostCallbackRegisterLogic from './utils/invokePostCallbackRegisterLogic';
import selectEventByDispId from './utils/selectEventByDispId';
import { ApiEventCallback } from './schema/ApiEventCallback';
import { isControlRegistered, setApiEventHandler } from './storage/ActiveApiEvents';
import { isUilessAddinRunning } from 'owa-addins-store';
import { OutlookEventDispId } from './schema/OutlookEventDispId';
import {
    getControlAlreadyRegisteredResult,
    getSuccessResult,
    ApiEventResult,
    isSuccess,
} from './schema/ApiEventResult';

export default function registerApiEvent(
    eventHandler: ApiEventHandler,
    args: ApiEventRegisterArgs,
    callback?: ApiEventCallback
) {
    if (isUilessAddinRunning(args.controlId) && isEventIgnoredInUILess(args.eventDispId)) {
        invokeCallback(callback, getSuccessResult());
        return;
    }
    const formattedArgs = formatArgs(args);
    const apiEvent = selectEventByDispId(args.eventDispId);
    let result = apiEvent.register(args.controlId, formattedArgs);
    if (isSuccess(result)) {
        result = saveEventHandler(args.controlId, args.eventDispId, eventHandler);
    }

    invokeCallback(callback, result);
    invokePostCallbackRegisterLogic(apiEvent, args.controlId);
}

function isEventIgnoredInUILess(dispId: OutlookEventDispId): boolean {
    switch (dispId) {
        case OutlookEventDispId.DIALOG_NOTIFICATION_SHOWN_IN_ADDIN_DISPID:
        case OutlookEventDispId.DISPLAY_DIALOG_DISPID:
            return false;
        case OutlookEventDispId.APPOINTMENT_TIME_CHANGED_EVENT_DISPID:
        case OutlookEventDispId.ITEM_CHANGED_EVENT_DISPID:
        case OutlookEventDispId.RECIPIENTS_CHANGED_EVENT_DISPID:
        case OutlookEventDispId.RECURRENCE_CHANGED_EVENT:
        case OutlookEventDispId.LOCATIONS_CHANGED_EVENT:
        case OutlookEventDispId.ATTACHMENTS_CHANGED_EVENT_DISPID:
            return true;
    }
}

function formatArgs(args: ApiEventRegisterArgs): any {
    return args.targetId ? JSON.parse(args.targetId) : null;
}

function saveEventHandler(
    controlId: string,
    eventDispId: OutlookEventDispId,
    eventHandler: ApiEventHandler
): ApiEventResult {
    if (isControlRegistered(controlId, eventDispId)) {
        return getControlAlreadyRegisteredResult();
    }

    setApiEventHandler(controlId, eventDispId, eventHandler);
    return getSuccessResult();
}
